// @core/api/endpoints/activity/list_activities.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListActivitiesResponse,
} from '../../../types/activity';

const BASE_PATH = '/activity';

/**
 * List activities by scope
 * Returns activities filtered by scope (entity, project, team, tenant). Used for Right Rail Activity tab and workspace Activity tabs. Supports filtering by category, verb, time range.
 */
export async function ListActivities(
  params?: {
    category?: string | number | boolean;
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    limit?: string | number | boolean;
    object_id?: string | number | boolean;
    scope?: string | number | boolean;
    scope_id?: string | number | boolean;
    sort?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListActivitiesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/activities`;
  const requestOptions = options;
  return client.get<ListActivitiesResponse>(requestPath, { ...requestOptions, params });
}
